(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'fabButton',
            [
                'CHROME',
                FabButtonFactory
            ]
        );

    // Factory Method
    function FabButtonFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            controller: 'FabController',
            controllerAs: 'fabCtrl',
            templateUrl: CHROME.PREFIX + CHROME.FAB.BUTTON + CHROME.POSTFIX
    };

    }
})();



